import { primaryBrandOrange } from 'shared/styles/muiTheme';

export const menuIndicatorBorder = '2px dashed rgba(0, 0, 0, 0.15)';

export const getEntityColor = (entity: any) => entity.titles_color ? entity.titles_color : primaryBrandOrange;